import { Skeleton, TextField } from "@mui/material";
import { Controller, get, useFormContext } from "react-hook-form";
import { Grid } from "@mui/material";
import AutoComplete from "src/components/shared/AutoComplete";

const FieldLabel = ({ label, required }) => (
  <span>
    {label}
    {required && <span style={{ color: "red", marginLeft: 2 }}>*</span>}
  </span>
);

const CustomerAutocomplete = ({ name, label, options, placeholder, loading, loadingMore, hasMore, onLoadMore, onInputChange, mt, xs, shouldUnregister, required, ...props }) => {
  const { control } = useFormContext();

  return loading ? (
    <Grid
      item
      xs={xs || 12}
      mt={mt}
    >
      <Skeleton
        width="100%"
        height="56px"
      />
    </Grid>
  ) : (
    <Controller
      control={control}
      name={name}
      rules={{ required: true }}
      render={({ field, formState: { errors } }) => {
        const error = get(errors, name);
        return (
          <Grid
            item
            xs={xs || 12}
            mt={mt}
          >
            <AutoComplete
              {...props}
              onChange={(_, value) => {
                props?.onChange?.(value);
                field.onChange(value || null);
              }}
              isOptionEqualToValue={(option, value) => option?.value === value?.value}
              options={options || []}
              value={field.value || null}
              getOptionLabel={(option) => option?.label ?? ""}
              loading={loading}
              hasMore={hasMore}
              loadingMore={loadingMore}
              onLoadMore={onLoadMore}
              filterOptions={(opts) => opts}
              onInputChange={onInputChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={
                    <FieldLabel
                      label={label}
                      required={required}
                    />
                  }
                  placeholder={placeholder}
                  error={!!error}
                  helperText={error?.message}
                  disabled={props.disabled}
                />
              )}
            />
          </Grid>
        );
      }}
    />
  );
};

export default CustomerAutocomplete;
